import { reactToastify as reactToastifyV3 } from 'v3/common/utils/reactToastify';

// TODO this needed to be moved to v3 , this is temp fix
export const TOASTIFY_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default'
};

export const reactToastify = (message, type = TOASTIFY_TYPES.INFO, options = {}) => reactToastifyV3(message, type, options)
